import React from "react";
import isEmpty from "lodash/isEmpty";
export var useEditUserNameAndEmail = function (initial) {
    var _a = React.useState(initial.name), name = _a[0], setName = _a[1];
    var _b = React.useState(initial.email), email = _b[0], setEmail = _b[1];
    var _c = React.useState({}), errors = _c[0], setErrors = _c[1];
    var validate = function () {
        var validated = {};
        // if (name.length === 0 && email.length === 0) {
        //   validated.name = "Необходимо заполнить логин или почту.";
        //   validated.email = "Необходимо заполнить логин или почту.";
        // }
        //
        // if (email.length > 0 && !isValidEmail(email)) {
        //   validated.email = "Неверный формат почты";
        // }
        setErrors(validated);
        return isEmpty(validated);
    };
    return {
        validate: validate,
        errors: errors,
        name: { value: name, set: setName },
        email: { value: email, set: setEmail },
    };
};
